import {
    CAMPUS_BERKELEY,
    CAMPUS_DAVIS,
    CAMPUS_IRVINE,
    CAMPUS_MERCED,
    CAMPUS_RIVERSIDE,
    CAMPUS_SAN_DIEGO,
    CAMPUS_SANTA_BARBARA,
    CAMPUS_SANTA_CRUZ,
    CAMPUS_UCLA,
    HOUSING_COMMUTER,
    HOUSING_OFF_CAMPUS,
    HOUSING_ON_CAMPUS,
    RESIDENCY_CALIFORNIA, RESIDENCY_OTHER
} from "./MAGIC_NUMBERS";

//  Data used for form elements in step 2 and step 3
const FORM_DATA = {
    campusList: [
        {value: 0, text: 'Select Campus'},
        {value: CAMPUS_BERKELEY, text: 'UC Berkeley'},
        {value: CAMPUS_DAVIS, text: 'UC Davis'},
        {value: CAMPUS_IRVINE, text: 'UC Irvine'},
        {value: CAMPUS_UCLA, text: 'UCLA'},
        {value: CAMPUS_MERCED, text: 'UC Merced'},
        {value: CAMPUS_RIVERSIDE, text: 'UC Riverside'},
        {value: CAMPUS_SAN_DIEGO, text: 'UC San Diego'},
        {value: CAMPUS_SANTA_BARBARA, text: 'UC Santa Barbara'},
        {value: CAMPUS_SANTA_CRUZ, text: 'UC Santa Cruz'}
    ],
    housingList: [
        {value: 0, text: 'Select Housing Type'},
        {value: HOUSING_ON_CAMPUS, text: 'On Campus'},
        {value: HOUSING_OFF_CAMPUS, text: 'Off Campus'},
        {value: HOUSING_COMMUTER, text: 'Living at Home'}
    ],
    residencyList: [
        {value: 0, text: 'Select Residency Status'},
        {value: RESIDENCY_CALIFORNIA, text: "California Resident"},
        {value: RESIDENCY_OTHER, text: "Nonresident"}
    ],
    costsList: [
        {value: 'ucTuition', text: 'UC Tuition'},
        {value: 'campusFees', text: 'Campus Fees'},
        {value: 'healthInsurance', text: 'Health Insurance Allowance/Fee'},
        {value: 'housingAndMeals', text: 'Housing and Meals'},
        {value: 'booksAndSupplies', text: 'Books and Supplies'},
        {value: 'personalAndTransportation', text: 'Personal and Transportation'}
    ]
};
export default FORM_DATA;